import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  PurchaseHistoryParams,
  ResellerPurchaseHistoryResponseData,
  TransactionDetailsResponse
} from 'mbs-ui-shared@components/purchase-history/models/purchase-history.types';
import { PagedResponse } from 'mbs-ui-shared@models/Paging';
import { Observable } from 'rxjs';

@Injectable()
export class ResellerPurchaseHistoryService {
  private httpClient = inject(HttpClient);

  private readonly resellerBaseHref = '/api/purchase-history';

  public getHistory(params: PurchaseHistoryParams): Observable<PagedResponse<ResellerPurchaseHistoryResponseData>> {
    return this.httpClient.get<PagedResponse<ResellerPurchaseHistoryResponseData>>(this.resellerBaseHref, {
      params,
      withCredentials: true
    });
  }

  public exportHistory(params: PurchaseHistoryParams): Observable<string> {
    return this.httpClient.get(`${this.resellerBaseHref}/export`, { params, responseType: 'text', withCredentials: true });
  }

  public getDetails(id: string): Observable<TransactionDetailsResponse> {
    return this.httpClient.get<TransactionDetailsResponse>(`${this.resellerBaseHref}/${id}/details`, { withCredentials: true });
  }

  public getInvoicePdf(id: string) {
    return this.httpClient.get(`${this.resellerBaseHref}/${id}/invoice`, {
      withCredentials: true,
      observe: 'response',
      responseType: 'blob'
    });
  }

  public getReceiptPdf(id: string) {
    return this.httpClient.get(`${this.resellerBaseHref}/${id}/receipt`, {
      withCredentials: true,
      observe: 'response',
      responseType: 'blob'
    });
  }
}
